// extracted by mini-css-extract-plugin
export default {"searchComponent":"Search_searchComponent__LgXR9","adornment":"Search_adornment__8h2Sv","isSearch":"Search_isSearch__bDN3z","clear":"Search_clear__VNA6E"};